import React, { useState, useEffect } from "react";
import { ethers } from "ethers";
import {
  useAppKitProvider,
  useAppKitAccount,
} from "@reown/appkit/react";

import tokenAbi from "../../Connectivity/abi/tokenAbi.json";
import marketplaceAbi from "../../Connectivity/abi/marketplace.json";
import { putOnSale, buySellTransactionHash } from "../../../redux/admin/action";
import PagesIndex from "../../PagesIndex";
import WalletLoader from "../../../components/common/WalletLoader";
import CircularProgress from "@mui/material/CircularProgress";

export default function PutOnSale() {
  const { walletProvider } = useAppKitProvider("eip155");
  const navigate = PagesIndex.useNavigate();
  const location = PagesIndex.useLocation();
  const themeColor = new URLSearchParams(location.search).get("mode");

  const [processingLog, setProcessingLog] = useState();
  const { wallet_address, id, nft_id, amount, userId } = PagesIndex.useParams();
  // console.log(wallet_address, id, nft_id, amount);
  const [price, setPrice] = useState(amount);
  const [tokenId, setTokenId] = useState(nft_id);
  const [isVisible, setIsVisible] = useState(true);
  const { isConnected } = useAppKitAccount();
  const [loading, setLoading] = useState(false);

  async function handleSell(price, tokenId) {
    // console.log(price, tokenId);
    setLoading(true);
    setProcessingLog("Putting idea on sell...", price, tokenId);
    const provider = new ethers.providers.Web3Provider(walletProvider);
    const signer = provider.getSigner();
    const balance = await signer.getBalance();
    const gasPrice = await provider.getGasPrice();
    let gasCost;
    const contract = new ethers.Contract(
      "0x00126A59c2F6322Fd53FcAd3B2B01C471D41468e",
      marketplaceAbi,
      signer
    );
    try {
      if (Number(balance.toString()) === 0) {
        setProcessingLog("You have insufficient MATIC balance in your wallet");
        setLoading(false);
        return;
      } else {
        setProcessingLog("");
      }
      console.log("PRIII : ", price.toString(), price);
      const totaltoWei = ethers.utils.parseEther(price.toString());
      let sellEstimatedGasLimit = await contract.estimateGas.sellNFT(
        "0xaAcaA93ebeb434d8A9E0363623f677A92F735c81",
        tokenId,
        totaltoWei
      );
      gasCost = gasPrice.mul(sellEstimatedGasLimit);
      if (balance.lt(gasCost)) {
        setProcessingLog("You have insufficient gas fees for this transaction");
        setLoading(false);
      }
      let platformfee = await contract.sellNFT(
        "0xaAcaA93ebeb434d8A9E0363623f677A92F735c81",
        tokenId,
        totaltoWei
      );
      // console.log(platformfee.hash, " hash 123");
      await platformfee.wait();
      setProcessingLog("Approving the transactions...");
      //console.log("dhgfdsf", platformfee);
      let nftSaleIDfinal = await getSaleId(platformfee);

      const txReceipt = await provider.getTransactionReceipt(platformfee.hash);
      // console.log(txReceipt, "txReceipt", txReceipt.status);
      // console.log(platformfee, "platformfee", platformfee.hash);
      // console.log(nftSaleIDfinal, "nftSaleIDfinal");

      if (txReceipt.status === 1) {
        if (platformfee.hash && nftSaleIDfinal) {
          // Transaction hash save
          let transactionHashData = {
            type: "Sell",
            nftId: id,
            price: price,
            transactionHash: platformfee.hash,
          };
          buySellTransactionHash(transactionHashData);

          let values = {
            id: id,
            price: price,
            nftSmartContractId: tokenId,
            walletAddress: wallet_address,
            tx_hash: platformfee.hash,
            saleId: nftSaleIDfinal,
            sellerId: userId,
          };
          setProcessingLog("Performing transaction updates...");
          setTimeout(() => {
            putOnSale(values).then((res) => {
              if (res?.status === 201) {
                setLoading(false);
                setProcessingLog("Payment done. Go Back to your app. 201");
                navigate("/wallet/success");
              } else {
                setLoading(false);
                setProcessingLog("Payment done. Go Back to your app.");
                navigate("/wallet/success");
              }
              setProcessingLog("");
            });
          }, 1000);
        } else {
          setLoading(false);
          alert("Transaction is not completed. please try again");
        }
      } else {
        setLoading(false);
        alert("Transaction failed");
      }
    } catch (error) {
      console.error("Error while approving:", error);
      setLoading(false);
      alert(error?.message);
      // console.log("error?.message", error?.message)
    }
  }

  const getSaleId = async (feeTransfer) => {
    try {
      const provider = new ethers.providers.Web3Provider(walletProvider);
      const receipt = await provider.getTransactionReceipt(feeTransfer?.hash);
      // console.log("receipt : ", receipt);
      if (receipt && receipt.logs) {
        const tokenInterface = new ethers.utils.Interface([
          "event SellDetails(address indexed sellerAddress,uint256 indexed selllId,uint256 indexed tokenId,uint256 price)",
        ]);
        const transferLog = receipt.logs.find((log) =>
          log.topics.includes(tokenInterface.getEventTopic("SellDetails"))
        );
        //console.log(await transferLog.topics[2], "logData");
        let value = await transferLog.topics[2];
        let saleId = parseInt(value, 16);
        return saleId;
      } else {
        console.log("No logs found in the transaction receipt.");
      }
    } catch (error) {
      console.error("Error:", error);
    }
  };

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsVisible(false);
    }, 4000);
    return () => clearTimeout(timer);
  }, []);

  // 10 Min timer
  const [timeLeft, setTimeLeft] = useState(600); // 600 seconds = 10 minutes
  useEffect(() => {
    if (loading) {
      const timer = setInterval(() => {
        setTimeLeft((prevTime) => {
          if (prevTime <= 1) {
            clearInterval(timer);
            return 0;
          }
          return prevTime - 1;
        });
      }, 1000);
      return () => clearInterval(timer); // Clean up the interval on component unmount
    } else {
      setTimeLeft(600);
    }
  }, [loading]);

  const formatTime = (seconds) => {
    const minutes = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${minutes.toString().padStart(2, "0")}:${secs
      .toString()
      .padStart(2, "0")}`;
  };

  return (
    <>
      <div
        //className="wallet-box"
        className={`${
          themeColor === "dark"
            ? "wallet-box wallet-box-content-dark"
            : "wallet-box wallet-box-content"
        }`}
      >
        <div className="wallet-box-cont">
          <div className="logo-box">
            <img src={PagesIndex.Png.logo2} alt="" />
            <div className="logo-title">EPISAP</div>
          </div>
          <appkit-button />
          <h4 className="wallet-title">
            Putting Idea On Sale <br />
            {price} SAP
          </h4>
          <div className="wallet-btn-approve">
            <button
              onClick={() => handleSell(price, tokenId)}
              disabled={!isConnected || loading}
              className={`loader-white ${!isConnected ? "disable-color" : ""}`}
            >
              {loading == true ? <CircularProgress size={16} /> : "Confirm"}
            </button>
          </div>
          <div className="wallet-subtitle">{processingLog}</div>
          {loading && (
            <div className="payment-timer">
              <p>
                <strong>
                  The payment is still processing. Please don't close the app or
                  turn off your screen. Wait until you get a response from the
                  wallet. If you don't, you might lose your data.
                </strong>
              </p>
              <h3>Countdown Timer</h3>
              <div style={{ fontSize: "1.5rem" }}>{formatTime(timeLeft)}</div>
            </div>
          )}
        </div>
      </div>
      {isVisible && (
        <div className="wallet-loader">
          <WalletLoader />
        </div>
      )}
    </>
  );
}
